import { Type } from '@angular/core'

import { Card } from 'app/core/cms/type-unions'

import { CmsBlock } from '../cms-block'
import { CardFileDownloadComponent } from './card-file-download/card-file-download.component'
import { CardImageTextComponent } from './card-image-text/card-image-text.component'
import { CardProjectComponent } from './card-project/card-project.component'
import { CardPublicationComponent } from './card-publication/card-publication.component'
import { CardSwissBillQrCodeDonationComponent } from './card-swiss-bill-qr-code-donation/card-swiss-bill-qr-code-donation.component'

type CardMapping = {
  [key in Card['__typename']]: Type<CmsBlock<Card & { __typename: key }>>
}

export const CARD_MAPPING = {
  CardProject: CardProjectComponent,
  CardPublication: CardPublicationComponent,
  CardImageText: CardImageTextComponent,
  CardFileDownload: CardFileDownloadComponent,
  CardSwissBillQrCodeDonation: CardSwissBillQrCodeDonationComponent,
} as const satisfies CardMapping
